{
  "id": "cbo",
  "nome": "CBO 2002 — Brazilian Occupations",
  "fonte": "MTE CBO 2002 ocupacao.csv",
  "endpoints": [
    "https://www.gov.br/trabalho-e-emprego/pt-br/assuntos/cbo/servicos/downloads/cbo2002-ocupacao.csv"
  ],
  "capturadoEm": "2026-08-05",
  "atualizadoEm": "2026-08-05T06:10:43.620Z",
  "contagens": {
    "cbo": 2694
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-08-04"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-05T06:10:43.620Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#cbo-occupations"
}
